import getMediaURL from 'utils/getMediaURL'

export default function setPreview({ props, state }) {
  const { id, media, relativeOutputPath } = props.payload
  const mediaInView = state.get(`media.files.${id}`)
  const url = getMediaURL(`${relativeOutputPath}/${media}`)
  if (mediaInView) {
    state.set(`media.files.${id}.preview`, url)
    state.set('media.details.preview', url)
    state.set('media.details.previewUploaded', true)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Socket/actions/setPreview.js